import i18n from "utilities/i18n";
import { C10PdiFragment } from "generated/graphql";

export type PrimaryDeviceInfo = {
  [k in keyof Omit<C10PdiFragment, "__typename">]?: string;
};

export const columnTranslations: Required<Omit<
  PrimaryDeviceInfo,
  "__typename"
>> = {
  hardwaremodel: i18n.t("HARDWARE_MODEL"),
  macaddress: i18n.t("MAC_ADDRESS"),
  serialnumber: i18n.t("SERIAL_NUMBER"),
  offsetgmt: i18n.t("OFFSET_GMT"),
  productfamily: i18n.t("FAMILY"),
  hardwarerevision: i18n.t("HARDWARE_REVISION"),
  manufacturer: i18n.t("MANUFACTURER"),
  softwarebuild: i18n.t("SOFTWARE_BUILD"),
  softwarerelease: i18n.t("SOFTWARE_RELEASE"),
  uploadtime: i18n.t("UPLOAD_TIME"),
  versioninfo: i18n.t("VERSION_INFO"),
  powersource: i18n.t("POWER_SOURCE"),
  updaterversion: i18n.t("UPDATER_VERSION"),
  hardwarepn: i18n.t("HARDWARE_PN"),
  regioncode: i18n.t("REGION_CODE"),
  deviceid: i18n.t("DEVICE_ID"),
  featurevariation: i18n.t("FEATURE_VARIATION"),
  hostos: i18n.t("hostos"),
  hostosbuild: i18n.t("HOSTOS_BUILD"),
  hostosversion: i18n.t("HOST_VERSION"),
  devicesignature: i18n.t("DEVICE_SIGNATURE"),
  eventmonotonictime: i18n.t("EVENT_MONOTONIC_TIME"),
  hosthardware: i18n.t("HOST_HARDWARE"),
  productid: i18n.t("PRODUCT_ID"),
  productname: i18n.t("PRODUCT_NAME"),
  proxyagent: i18n.t("PROXY_AGENT"),
  proxyagentversion: i18n.t("PROXY_AGENT_VERSION"),
  reboottype: i18n.t("REBOOT_TYPE"),
  proxyagentid: i18n.t("PROXY_AGENT_ID")
};
